
import React, { PureComponent } from 'react';
import { Icon, Input} from 'antd';
import {RTLCol} from "../RTLKit";




export default class TextAreaField extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {

    const { TextArea } = Input;

    const {
        input,
        label,
        iconName,
        rows,
        meta: { touched, error, warning },
    } = this.props;

      let defaultValue = null
      if(input.value)
          defaultValue = input.value

      return (
        <div>
            <RTLCol span={24}>
                <RTLCol className="formLabel" md={label ? 5 : 0} sm={24}>
                    {label ? <label>{label} : </label> : null}
                </RTLCol>
                <RTLCol md={label ? 15 : 19} sm={24}>
                    <div>
                        <TextArea
                            {...input}
                            prefix={<Icon type={iconName} style={{ color: 'rgba(0,0,0,.25)' }} />}
                            placeholder={label}
                            rows={rows}
                            value={defaultValue}
                        />
                    </div>
                </RTLCol>
                <RTLCol md={3} sm={24}>
                    {touched &&
                    ((error && <span className="errorMsg">{error}</span>) ||
                        (warning && <span className="warningMsg">{warning}</span>))}
                </RTLCol>
            </RTLCol>
        </div>
    );
  }
}



